<script>
	// Stores 
	import { 
		textSite,
		mailSeguros
	 } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader	from "../components/PageHeader.svelte";
	import Forms from "../components/Forms.svelte";  

   	// Code	
	let titlePage = 'Seguro Conteúdo ';

	let mensagem = GetHash('assunto') == null ? '' : GetHash('assunto');

	let fields = [
		{
			title:  'Nome *',
			name:   'nome',
			required:   'required'
		},
		{
			title:  'Telefone *',
			name:   'telefone',
			required: 'required',
		},
		{
			title:  'Email *',
			name:   'email',
			type: 'email',
			required: 'required',
		},
		{
			title:             'Mensagem *',
			name:              'mensagem',
			defaultValue:      'Solicito contato sobre seguros.',
			required:          'required',
			type:              'textarea',
			rows: 4
		}
	];

	const message = `
Nome: {nome}
Telefone: {telefone}
Email: {email}
Mensagem: {mensagem}

{info}
	`;

	let loading = false;
	function send() {
		loading = true;
	}

</script>

<PageHeader title={titlePage} buttons="">
	<div class="subtitle" slot="subtitle">
		<div class="container pr-400 sm-pr-0">
			<h2>PROTEJA SEUS BENS</h2>
			<img src="/assets/images/seguros/imgFire.png" alt="" aria-disabled="true" style="max-width: none; width: 350px;" />
			<p class="mt-20">Seguro contra incêndio que irá cobrir o conteúdo existente dentro do imóvel (eletrodomésticos, móveis, roupas, entre outros), podendo ser contratado por proprietários e inquilinos, tanto para imóveis residenciais como comerciais em condomínio. Portanto este seguro complementa o seguro do condomínio e o seguro da locação que são feitos normalmente somente para o incêndio do prédio.</p>
		</div>
	</div>
</PageHeader>

<div class="container clearfix text-justify">
	<div class="flex">
		<div class="text-subtitle pl-20 pr-20 pt-5" style="color: #95b8df; text-transform: uppercase;">Opcional no seu doc.</div>
	</div>	
	<div class="flex flex-center sm-flex-column gap-10 pt-10 pb-20 text-center">
		<div class="flex flex-column flex-1 pa-20 gap-20">

			<div class="item round-all p-20 text-left" style="border: 1px solid #eeeeee;">
				<h3 class="text-bold pt-20" style="color: #213059; font-weight: 800; text-transform: uppercase;">Adesão Facilitada</h3>
				<p>
					O valor do seguro vem incluído no valor total do boleto, o pagamento indica a adesão do cliente ao seguro. Caso o cliente não queira contratar basta descontar o valor ao fazer o pagamento.
				</p>
			</div>
			
			<div class="item round-all p-20 text-left" style="border: 1px solid #eeeeee;">
				<h3 class="text-bold pt-20" style="color: #213059; font-weight: 800; text-transform: uppercase;">Vigência do Seguro</h3>
				<p>
					Mês seguinte ao pagamento. O seguro terá validade no mês seguinte ao pagamento e o boleto pago serve como comprovante do seguro.
				</p>
			</div>
			
			<div class="item round-all p-20 text-left" style="border: 1px solid #eeeeee;">
				<h3 class="text-bold pt-20" style="color: #213059; font-weight: 800; text-transform: uppercase;">Serviços de Assistência</h3>
				<p>Serviços Emergenciais de Encanador - Eletrecista - Chaveiro</p>
				<p>Serviços de conserto para linha branca (Geladeira, Fogão, Micro-ondas e máquina de lavar roupas, etc.)</p>
				<p>Atendimento exclusivo:</p>

				<h3 class="text-bold pt-20 pb-20" style="color: #213059; font-weight: 800; text-transform: uppercase;">0800-702-5100</h3>

				<p>
					<a class="btn btn-rounded btn-primary" style="border: 2px solid #ffffff !important;" target="_blank" href="/assets/files/ManualResidencial53a58SeguradoYelum Imobiliaria_Out24.pdf">
						<b>Manual - Imobiliário Residencial</b>
					</a>
					<a class="btn btn-rounded btn-primary" style="border: 2px solid #ffffff !important;" target="_blank" href="/assets/files/ManualSegurado128a132YelumCeS_Out2024.pdf">
						<b>Manual - Imobiliário Empresarial</b>
					</a>
				</p>

				<div class="pt-20 p-20 round-all" style="background-color: #95b8df; padding: 10px 20px; display: flex;">
					<div class="gap-20" style="padding-right: 10px;"><i class="far fa-exclamation fa-2x" style="color: #213059;"></i></div>
					<div class="flex-1">
						Este material é apenas um resumo. Consulte as informações detalhadas das coberturas, exclusões e procedimentos nos respectivos Manuais de Assistência 24 horas, disponíveis no site da seguradora.
					</div>
				</div>

			</div>
		</div>
		<div class="flex flex-column pa-20 gap-40 flex-center" style="text-align: center;">
			<div class="item">
				<div class="flex flex-center">
					<img src="/assets/images/seguros/RFSSeguros.png" border="0" alt="RFS Seguros" style="max-width: 100%" />
				</div>
			</div>
			<div class="item">
				<div class="flex flex-center">
					<img src="/assets/images/seguros/imgService.jpg" border="0" alt="Serviços" style="max-width: 100%" />
				</div>
			</div>
			<div class="item">
				<div class="flex flex-center">
					<img src="/assets/images/seguros/imgPump.jpg" border="0" alt="Consertos" style="max-width: 100%" />
				</div>
			</div>
		</div>
	</div>


	<div class="flex flex-center sm-flex-column gap-10 pt-10 text-left" style="color: #19325c;">
		<div><h2 style="font-weight: bold;text-align: center;">SEGURO CONTEÚDO</h2></div>
	</div>	

	<div class="flex flex-center sm-flex-column gap-10 text-left" style="color: #19325c;">
		<div><h4 style="background-color: #fbdb60;border-radius: 6px;text-align: center;padding: 5px;font-weight: bold;">CONHEÇA AS COBERTURAS</h4></div>
	</div>	

	<div class="flex flex-start sm-flex-column gap-10 pt-10 pb-20 text-left" style="color: #19325c;">
		
		<div class="flex flex-start flex-column flex-1 pa-20 gap-20">

			<div class="pt-20 p-20 round-all flex-wrap" style="padding: 10px 20px; display: flex; border: 1px solid #eeeeee;">
				<div class="gap-20" style="padding-right: 20px;">
					<img src="/assets/images/seguros/icoIncendio.png" border="0" alt="Incêndio" style="max-width: 100px" />
				</div>
				<div class="flex-1">
					<h3><b>INCÊNDIO</b></h3>
					<div>
						<b>Residencial RS 120.000,00</b><br />
						<b>Comercial RS 100.000,00</b><br />
						Cobertura de incêndio, Raio e explosão.
					</div>
				</div>
			</div>

			<div class="pt-20 p-20 round-all flex-wrap" style="padding: 10px 20px; display: flex; border: 1px solid #eeeeee;">
				<div class="gap-20" style="padding-right: 20px;">
					<img src="/assets/images/seguros/icoCivil.png" border="0" alt="Responsabilidade Civil" style="max-width: 100px" />
				</div>
				<div class="flex-1">
					<h3><b>RESPONSABILIDADE CIVIL</b></h3>
					<div>
						<b>Residencial R$ 23.000,00</b><br />
						<b>Comercial R$ 20.000,00</b><br />
						Garante pagar as quantias devidas e/ou reembolsar as despendidas, pelo Segurado, na reparação de danos materiais e/ou corporais causados a terceiros.
					</div>
				</div>
			</div>

			<div class="pt-20 p-20 round-all flex-wrap" style="padding: 10px 20px; display: flex; border: 1px solid #eeeeee;">
				<div class="gap-20" style="padding-right: 20px;">
					<img src="/assets/images/seguros/ico24h.png" border="0" alt="Assistência 24h" style="max-width: 100px" />
				</div>
				<div class="flex-1">
					<h3><b>ASSISTÊNCIA 24 HS</b></h3>
					<div>
						<b>Residencial R$ 16,90</b><br />
						<b>Comercial R$ 26,90</b><br />
						Serviços emergenciais de encanador, eletricista e chaveiro.
					</div>
				</div>
			</div>

			<div class="mt-20 pt-20 p-20 round-all" style="background-color: #19325c; padding: 10px 20px; display: flex;">
				<div class="flex-1 flex-center " style="color: #ffffff; text-align: center;">
					<h4><b>SOLICITAÇÃO DE SERVIÇOS DE ASSISTÊNCIA</b></h4><br />
					<h2><b>0800 702 5100</b></h2>
				</div>
			</div>

		</div>
		<div class="flex flex-start flex-column flex-1 pa-20 gap-20">

			<div class="pt-20 p-20 round-all flex-wrap" style="padding: 10px 20px; display: flex; border: 1px solid #eeeeee;">
				<div class="gap-20" style="padding-right: 20px;">
					<img src="/assets/images/seguros/icoAluguel.png" border="0" alt="Perda e pagto de aluguel" style="max-width: 100px" />
				</div>
				<div class="flex-1">
					<h3><b>PERDA E PAGAMENTO DE ALUGUEL</b></h3>
					<div>
						<b>Residencial R$ 15.000,00</b><br />
						<b>Comercial RS 20.000,00</b><br />
						Refere-se a indenização pela perda ou despesas com aluguel, em decorrência de riscos amparados na cobertura Básica de Incêndio, Raio e Explosão.
					</div>
				</div>
			</div>

			<div class="pt-20 p-20 round-all flex-wrap" style="padding: 10px 20px; display: flex; border: 1px solid #eeeeee;">
				<div class="gap-20" style="padding-right: 20px;">
					<img src="/assets/images/seguros/icoVazamento.png" border="0" alt="Vazamento acidental" style="max-width: 100px" />
				</div>
				<div class="flex-1">
					<h3><b>VAZAMENTO ACIDENTAL</b></h3>
					<div>
						<b>Residencial RS 5.000,00</b><br />
						Cobertura para os danos causados aos bens segurados, decorrentes de vazamentos acidentais da rede particular de água e esgoto da residência segurada.
					</div>
				</div>
			</div>	

			<div class="flex flex-column pt-20 p-20 round-all" style="padding: 10px 20px; display: flex; border: 1px solid #eeeeee;">
				<div class="flex flex-1 center flex-wrap" style="justify-content: center;">
					<div class="gap-20" style="padding-right: 30px; text-align: center;">
						<img src="/assets/images/seguros/icoEncanador.png" border="0" alt="Encanador" style="max-width: 100px" />
						<div><b>ENCANADOR</b></div>
					</div>
					<div class="gap-20" style="padding-right: 30px; text-align: center;">
						<img src="/assets/images/seguros/icoChaveiro.png" border="0" alt="Chaveiro" style="max-width: 100px" />
						<div><b>CHAVEIRO</b></div>
					</div>
					<div class="gap-20" style="padding-right: 30px; text-align: center;">
						<img src="/assets/images/seguros/icoEletrecista.png" border="0" alt="Eletrecista" style="max-width: 100px" />
						<div><b>ELETRECISTA</b></div>
					</div>
				</div>
				<div class="flex flex-row pt-10">
					<div>
						Confira os serviços prestados pela assistência tanto nas situações emergenciais quanto na ocorrência de sinistros nos imóveis atendidos pela imobiliária.
					</div>
				</div>				
			</div>

			<div class="flex flex-column pt-20 p-20 round-all" style="padding: 10px 20px; display: flex;">
				<div class="flex flex-1 center flex-wrap flex-end" style="justify-content: center;">
					<div class="gap-20" style="padding-right: 30px; text-align: center;">
						<img src="/assets/images/seguros/RFSSeguros.png" border="0" alt="RFS Seguros" style="max-width: 100%" />
					</div>
					<div class="gap-20" style="padding-top: 30px; text-align: center;">
						<img src="/assets/images/seguros/Yelum.png" border="0" alt="Yelum" style="max-width: 145px" />
					</div>
				</div>
			</div>	

		</div>
	</div>

</div>
<div class="background-gray">
	<div class="container clearfix">
		<div class="text-subtitle text-bold pt-30">Contato</div>	
		<p class="pt-10 pb-20 m-0">Para dúvidas, esclarecimentos ou qualquer auxílio necessário teremos prazer em auxiliar. Email: atendimento@rfsseguros.com.br ou ligue para a RFS Seguros:</p>
		<div class="flex flex-center sm-flex-column gap-20 sm-gap-5 pb-30">
			<div class="flex flex-column flex-1">
				<a href="tel://555132319399" class="flex flex-center gap-10 text-bold "><i class="fas fa-phone-volume fa-2x" style="color: #4267B2;"></i> <span>(51) 3231-9399</span></a>			
			</div>
			<div class="flex flex-column flex-1">
				<a href="https://wa.me/5551997012973" class="flex flex-center gap-10 text-bold "><i class="fab fa-whatsapp color-whatsapp fa-2x"></i> <span>(51) 99701-2973</span></a>
			</div>
			<div class="flex flex-column flex-1">
				<a href="https://www.instagram.com/rfssegurospoa/" class="flex flex-center gap-10 text-bold "><i class="fab fa-instagram fa-2x" style="color: #E1306C;"></i> <span>@rfssegurospoa</span></a>
			</div>
		</div>
		<hr>
		<p class="pt-10 pb-20 m-0">Você também pode utilizar o formulário abaixo para entrar em contato conosco:</p>
		<div class="flex flex-center sm-flex-column gap-20 sm-gap-5 pb-30">
			<Forms fields={fields} subject={titlePage} {message} htmlbody={false} destiny={$mailSeguros} />
		</div>
	</div>
</div>